const types = {
    SET_GET_PRESENT: '[PRESENT] SET GET PRESENT',
}

export {
    types,
}